module.exports = __webpack_public_path__ + "static/media/championsleague.f33ec7b4.jpg";